"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.upload.choose': 'Elegir archivo...',
    'file.upload.change': 'Cambiar archivo',
    'file.upload.remove': 'Eliminar archivo',
    'file.upload.loading': 'Cargando...',
    'file.upload.drop': 'Soltar archivo aquí',
    'file.upload.download': 'Descargar archivo',
    'file.upload.choose_multiple': 'Elegir archivos...',
    'file.upload.change_multiple': 'Cambiar archivos',
    'file.upload.remove_all': 'Eliminar todos los archivos',
    'file.upload.error.size_too_large': 'El archivo "{fileName}" es demasiado grande. El tamaño máximo de archivo es 2MB.',
    'file.upload.error.size_exceeded_10mb': 'El archivo "{fileName}" es demasiado grande. El tamaño máximo de archivo es {maxSize}.',
    'file.upload.error.multiple_files_size_exceeded_10mb': 'Los siguientes archivos son demasiado grandes: {fileNames}. El tamaño máximo de archivo es {maxSize}.',
    'file.upload.error.image_too_large': 'La imagen "{filename}" ({size}) es demasiado grande. Las imágenes deben ser menores a {maxSize}.',
    'file.upload.error.unsupported_type': 'Tipo de archivo no compatible. Por favor seleccione un formato de archivo compatible.',
    'file.upload.confirm.add_to_knowledge': 'El archivo "{fileName}" ({fileSize}) es demasiado grande para el chat. ¿Te gustaría agregarlo a la base de conocimientos en su lugar?',
    'file.upload.error.total_size_exceeded': 'Agregar este archivo excedería el límite total de 5MB. Total actual: {currentSize}, intentando agregar: {newSize}.',
    'file.upload.error.processing_failed': 'Error al procesar el archivo "{fileName}": {error}',
    'file.upload.error.upload_failed': 'Error al subir archivos: {error}',
    'file.upload.error.submission_failed': 'Error durante el envío del chat: {error}',
};
